<template>
	<div class="detail bg" v-if="loaded">
		<!-- <van-image :src="info.cover"  fit="cover" radius="3px"></van-image> -->
		<div class="title ">{{ info.title }}</div>
		<div class="lists">
			<div class="color333 font13 item">
				<span class="green">#参与人数</span>
				{{ info.players }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#点赞总数</span>
				{{ info.logs }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#评论总数</span>
				{{ info.comments }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#打赏总数</span>
				{{ info.rewards }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#开始时间</span>
				{{ info.start_at }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#结束时间</span>
				{{ info.end_at }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#实收金额</span>
				{{ info.revenue }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#退款金额</span>
				{{ info.refund }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#前{{info.winner_count}}名占比</span>
				 {{info.rate}}
			</div>
			<div class="color333 font13 item">
				<span class="green">#录取人数</span>
				{{ info.winner_count }}
			</div>
			<div class="color333 font13 item">
				<span class="green">#当前状态</span>
				{{ info.status }}
			</div>
		</div>
		<div class="ranking">
			<div class="title">详情排名</div>
			<div class="head">
				<div>#</div>
				<div class="item">姓名</div>
				<div class="item">票数</div>
				<div class="item">点赞</div>
				<div class="item">评论</div>
				<div class="item">打赏</div>
			</div>
			<div class="detail-list" v-for="(item, index) in info.list">
				<div>{{ index + 1 }}</div>
				<div class="item fw600">{{ item.name }}</div>
				<div class="item">{{ item.polls }}</div>
				<div class="item">{{ item.logs }}</div>
				<div class="item">{{ item.comments }}</div>
				<div class="item">{{ item.rewards }}</div>
			</div>
			<div class="pt30 fw500 pb30 mb20 color999 font12">{{ info.list.length > 0 ? '目前只显示这么多~' : '暂无数据~' }}</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
	name: 'detail',
	data() {
		return {
			loaded: false,
			lists: [],
			refreshing: false,
			refresh: false,
			loading: false,
			hasMore: true,
			page: 1,
			id: ''
		};
	},
	watch: {
		show: function(e) {
			if (e) {
				this.$nextTick(x => {
					this.$refs.input.focus();
				});
			}
		}
	},
	components: {
	},
	beforeMount() {
		if (this.$route.query.token) {
			this.login(this.$route.query.token);
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		this.getInfo();
	},
	activated() {
		this.rewards = this.$api.index.rewardsGlabel;
		this.logs = this.$api.index.logsGlabel;
		this.comments = this.$api.index.commentsGlabel;
		this.polls = this.$api.index.pollsGlabel;
	},
	methods: {
		...mapMutations(['login']),
		getInfo() {
			this.$api.index
				.analyticsDetail(this.id)
				.then(res => {
					this.info = res;
					this.loaded = true;
				})
				.catch(err => {});
		}
	}
};
</script>

<style scoped>
.title {
	text-align: left;
	color: #ffffff;
	background-color: rgba(2, 181, 205, 1);
	background-color: rgba(0,170,0,0.7);
	padding: 10px;
	line-height: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-radius: 6px 6px 0 0;
	font-size: 14px;
	font-weight: bolder;
}
.lists {
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.7);
	padding-bottom: 10px;
}
.lists .item {
	padding: 10px 0;
	border-bottom: solid 1px #f7f7f7;
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: flex-start;
	box-sizing: border-box;
	border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}
.ranking {
	margin-top: 10px;
	padding-bottom: 10px;
	background-color: rgba(255, 255, 255, 0.7);
	border-radius: 0 0 10px 10px;
}
.green {
	color: #333;
	font-size: 13px;
	font-weight: bold;
	margin-right: 30px;
}
.head {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
	padding: 10px 5px;
	background-color: rgba(255, 255, 255, 0.7);
	font-weight: bold;
	color: #333;
}
.head > .item {
	flex: 1;
}
.head > div:nth-child(1) {
	min-width: 30px;
}
.detail-list {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
	padding: 13px 5px;
	border-bottom: solid 1px rgba(0, 0, 0, 0.05);
	color: #444;
	border-radius: 0 0 3px 3px;
}
.detail-list > .item {
	flex: 1;
}
.detail-list > div:nth-child(1) {
	min-width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/detail.vue